module.exports = __webpack_public_path__ + "static/media/country_mp.0c95273f.webp";